/**
 * Normalizes `{ data: { list: [] } }` from freight admin index-style endpoints.
 * @param {object|null|undefined} res
 * @returns {object[]}
 */
export function freightAdminListFromResponse(res) {
  const list = res?.data?.list;
  return Array.isArray(list) ? list : [];
}

/**
 * @param {object|null|undefined} res
 * @param {string} key  e.g. `freightProfileStatusList`
 */
export function freightNamedListFromResponse(res, key) {
  const list = res?.data?.[key];
  return Array.isArray(list) ? list : [];
}

/**
 * Slider index: prefers `data.images` (`file` + `url`), else `freightAccountUnderReviewPageSliderList` names only.
 */
export function freightAccountUnderReviewSliderItems(res) {
  const d = res?.data;
  if (!d) return [];
  if (Array.isArray(d.images) && d.images.length > 0) {
    return d.images
      .map((x) => ({
        file: String(x?.file ?? "").trim(),
        url: x?.url != null ? String(x.url).trim() : ""
      }))
      .filter((x) => x.file);
  }
  const list = d.freightAccountUnderReviewPageSliderList;
  if (!Array.isArray(list)) return [];
  return list.map((f) => ({ file: String(f ?? "").trim(), url: "" })).filter((x) => x.file);
}
